module.exports = __webpack_public_path__ + "img/cake.e4afe949.png";